import {Navigate, useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {EmptyState} from 'pages/home/shared/DashboardUI';
import {MY_PERFORMANCE_PATH} from './performanceUtils';

const useRoleName = () =>
  useSelector(state => state?.auth?.userData?.user?.activeAdminTab?.name);

/**
 * The team report is for SUPERADMIN alone. A support agent who lands on it
 * (a link, a typed URL) is sent to their own numbers; anyone else gets this
 * notice. The report component, with its queries, is never mounted for them.
 */
export const PerformanceGate = ({children}) => {
  const roleName = useRoleName();
  const {search} = useLocation();
  if (roleName === 'SUPERADMIN') return children;
  if (roleName === 'CUSTOMER_SUPPORT') {
    return <Navigate to={`${MY_PERFORMANCE_PATH}${search}`} replace />;
  }
  return (
    <EmptyState
      title="Performance is for super admins"
      description="Your role can't see support performance. Ask a super admin if you need these numbers."
    />
  );
};

/** My performance: support agents, and super admins. */
export const MyPerformanceGate = ({children}) => {
  const roleName = useRoleName();
  if (['CUSTOMER_SUPPORT', 'SUPERADMIN'].includes(roleName)) return children;
  return (
    <EmptyState
      title="My performance is for support agents"
      description="Only support agents have personal support numbers."
    />
  );
};
